import { buildStaffMenu } from "./staffMenu"
// Also available for Centre Manager-specific tweaks: overrideByKey, removeByKey, addItems from "./helpers"

/**
 * Centre Manager role menu — cloned from the shared staff base.
 *
 * Currently mirrors the staff base exactly. To add Centre Manager-specific overrides
 * without affecting other roles, edit only this file. Example:
 *
 *   const menu = buildStaffMenu()
 *   return removeByKey(menu, "leave-request")
 */
export const buildCentreManagerMenu = () => buildStaffMenu()
